import fetch from 'isomorphic-fetch';
import { headers } from '../shared/constants';
import { settings } from './constants';
import { handleFetchedErrors } from '../shared/utils';

class Videos {
	constructor() {
		this.liveVideos = [];
		this.upcomingVideos = [];
		this.featureVideos = [];
	}
}

class FsgoVideosServices {
	constructor() {
		this.getVideosProm = null;
	}

	getVideos(zip, limit){
		if (this.getVideosProm) {
			return this.getVideosProm;
		}

		const options = Object.assign({ method: 'GET' }, headers);

		this.getVideosProm = fetch(`${settings.progsUrl}?zip=${zip || ''}&limit=${limit || ''}`, options)
			.then(handleFetchedErrors)
			.then(response => response.json())
			.then(json => {
				let result = new Videos();

				result.liveVideos = getItemsFromProg(json.live);
				result.featureVideos = getItemsFromProg(json.featured);
				result.upcomingVideos = getItemsFromProg(json.upcoming);

				return result;
			})
			.catch(() => new Videos());

		return this.getVideosProm;
	}
}

function getItemsFromProg(prog) {
	if (prog && prog.count > 0) {
		return prog.items || [];
	}

	return [];
}

export default new FsgoVideosServices();



// WEBPACK FOOTER //
// ./react-app-src/fsgo/FsgoVideosService.js